/**
* author: duxin
* date: 2020/4/7
* describe:
*/

<template>
	<div class="news-chunk" v-if="data[0].list.length > 0 || data[1].list.length > 0">
		<!-- <p class="p1">{{$t("home.information")}}</p> -->
		<div class="content-wrap">
			<div class="news-col" v-for="d in data" v-if="d.list.length>0">
				<div class="header">
					<h1>{{d.title}}</h1>
					<el-button
						class="more-bnt"
						type="text"
						v-if="d.list.length>4"
						plain
						size="mini"
						@click="onMore(d.id)"
					>{{$t("fromData.more")}}></el-button>
				</div>
				<div class="header">
					<div class="news-info"  :class="lang == 'en' ? 'news-info-en' : ''">
						<div v-for="item in d.list" class="news-item">
							<!-- <span class="avatar">{{item.title.substr(0, 1)}}</span> -->
							<div class="news-wrap">
								<h3 class="title" @click="onOpen(item,index)">{{item.title}}</h3>
								<p class="date">
									{{item.createTime}}
									<!-- <span>{{d.title}}</span> -->
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { GetNewList } from '../../../api/web'
import moment from 'moment'

export default {
	name: 'me-news-chunk',
	data() {
		return {
			data: [
				{
					title: this.$t('menu.company'),
					id: 'COMPANY',
					list: [],
				},
				{
					title: this.$t('menu.industry'),
					id: 'INDUSTRY',
					list: [],
				},
			],
		}
	},
	methods: {
		onOpen(item) {
			this.$router.push({ name: 'WEB', query: { newsId: item.newsId } })
		},
		onMore(id) {
			debugger
			this.$router.push({ name: id })
		},
		init() {
			let _objCom = {
				companyId: 2,
				pageNum: 1,
				pageSize: 5,
				newsType: 0,
			}
			let _objInd = {
				companyId: 2,
				pageNum: 1,
				pageSize: 5,
				newsType: 1,
			}
			let companyData = []
			let industryData = []
			Promise.all([GetNewList(_objCom), GetNewList(_objInd)]).then(
				(res) => {
					if (res[0].status) {
						companyData = res[0].data.dataList.map((item) => {
							item.createTime = moment(item.createTime).format(
								'YYYY/MM/DD'
							)
							return item
						})
					}
					if (res[1].status) {
						industryData = res[1].data.dataList.map((item) => {
							item.createTime = moment(item.createTime).format(
								'YYYY/MM/DD'
							)
							return item
						})
					}
					this.data[0].list = companyData
					this.data[1].list = industryData
				}
			)
		},
	},
	computed: {
		lang() {
			return sessionStorage.getItem('language')
		},
	},
	mounted() {
		this.init()
	},
}
</script>

<style scoped lang="less">
@import './chunk';
@import "../../../style/constant.less";

.news-chunk {
	margin: 0 auto;
	width: @page-width;
	padding: 100px 0;

	.content-wrap {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;

            .news-col {
                width: 48%;
                display: flex;
                flex-direction: column;

                .header {
                    display: flex;
                    justify-content: space-between;
					// align-items: center;
					width: 100%;
                }

                .header:first-child {
                    margin-bottom: 30px;
                }

                .header:last-child {
                    background: #FBFBFB;
                    border: 1px solid #EAEBF2;
					padding: 20px;
					width: ~"calc(100% - 40px)";
                }

                .news-info {
					width: 100%;
                    min-height: 355px;
                    // width: 50%;
				}
				.news-info-en {
                    min-height: 470px;
                }

			@media screen and (min-width: 320px) and (max-width: 480px) {
				.header:first-child {
					margin-bottom: 10px;
				}
				.header:last-child {
                    padding: 0px 15px 15px;
                }
				.news-info {
					width: 100%;
					margin-top: 15px;
					min-height: auto;
				}
			}

			.more-bnt {
				color: @title-info-color;
				align-self: center;
				position: relative;
			}
		}

		@media screen and (min-width: 320px) and (max-width: 480px) {
			.news-col {
				width: 100%;
				margin-bottom: 20px;
			}
		}

		.news-item {
			width: 100%;
			display: flex;
			margin-bottom: 25px;
			align-items: center;

                &:last-child {
                    margin-bottom: 0;
                }

                .avatar {
                    width: 65px;
                    height: 65px;
                    border-radius: 50%;
                    flex-shrink: 0;
                    border: 2px solid #435ba1;
                    text-align: center;
                    line-height: 65px;
                    font-size: 26px;
                    color: #435ba1;
                }

			.news-wrap {
				width: 100%;
				// margin-left: 15px;
				.title {
					width: 100%;
					color: @h2-color;
					word-wrap: break-word;

					&:hover {
						cursor: pointer;
						color: #435ba1;
					}
				}
				.date {
                    font-size: 14px;
                    color:#777777
				}
			}
		}
	}

	@media screen and (min-width: 320px) and (max-width: 480px) {
		.content-wrap {
			margin-top: 20px;
		}

		.date {
			font-size: 13px;
		}
	}
}

@media screen and (min-width: 320px) and (max-width: 480px) {
	.news-chunk {
		width: 90%;
		margin: 0px auto;
		overflow: hidden;
		padding: 40px 0;
	}
}
</style>
